// Types
import { ActionCreator } from 'redux';
import { ThunkAction } from 'redux-thunk';
import {
    HotTableStoreActions,
    HotTableStoreState,
    SetActiveTableAction,
    HotTableStoreActiveTable,
} from './hotTableStoreTypes';

// Selectors
import { getActiveTable } from './hotTableSelectors';

export const setActiveTable: ActionCreator<SetActiveTableAction, [HotTableStoreActiveTable | null]> = (
    activeTable,
) => ({
    type: 'SET_ACTIVE_TABLE',
    activeTable,
});

export const getActiveTableThunk =
    (): ThunkAction<HotTableStoreActiveTable | null, HotTableStoreState, unknown, HotTableStoreActions> =>
    (_, getHotTableState) =>
        getActiveTable(getHotTableState());
